import React, { PureComponent, Fragment } from 'react'
import { Button, TableRow, TableCell, Typography } from '@material-ui/core'
import { onChangeEditHOF } from '../../utils/common'

import { hasAccess } from '../../utils/api'
import { EditableTextField, EditableSwitch } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import ModalDialog from '../../components/common/ModalDialog'

class TookanShopInfoItem extends PureComponent {
  onChange = onChangeEditHOF(this.props.onChange)

  enableEdit = () => {
    this.props.enableEdit()
  }

  onSave = () => {
    const { isNotLinkedApiKey } = this.props
    if (!isNotLinkedApiKey) {
      this.confirmModal.handleClickOpen()
      return
    }
    this.props.onChange('resetTookan', false, () =>
      this.props.onSave(() => this.props.disableEdit()),
    )
  }

  onConfirm = () => {
    this.props.onChange('resetTookan', true, () =>
      this.props.onSave(() => {
        this.props.disableEdit()
        this.confirmModal.handleClose()
      }),
    )
  }

  onDelete = () => {
    const { data } = this.props
    this.props.onDelete(data.id)
  }

  render() {
    const { data = {}, editMode, isNotLinkedApiKey, shop = {} } = this.props

    return (
      <Fragment>
        <TableRow>
          <TableCell>{(shop && shop.name) || ''}</TableCell>
          <TableCell>
            <EditableTextField
              valueToRender={data.apiKey}
              value={data.apiKey}
              editMode={editMode}
              onChange={this.onChange('apiKey')}
            />
          </TableCell>
          <TableCell>
            <EditableSwitch
              valueToRender={data.active ? 'Enabled' : 'Disabled'}
              checked={data.active}
              editMode={editMode}
              onChange={this.onChange('active', true)}
            />
          </TableCell>
          {hasAccess() ? (
            <TableCell>
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.props.onCancel}
                onEdit={this.enableEdit}
                editMode={editMode}
                editTitle={!isNotLinkedApiKey ? 'Update' : 'Link'}
              />
              {!editMode && data.id ? (
                <Button className="danger-button margin" onClick={this.onDelete}>
                  Delete
                </Button>
              ) : null}
            </TableCell>
          ) : null}
        </TableRow>
        <ModalDialog
          title={''}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.onConfirm}
          confirmText={'Confirm'}
          onClose={this.resetPassword}
        >
          <Typography variant="subheading" gutterBottom>
            Reset Tookan information for shop?
          </Typography>
        </ModalDialog>
      </Fragment>
    )
  }
}

export default TookanShopInfoItem



// WEBPACK FOOTER //
// ./src/components/Tookan/TookanShopInfoItem.js